import axios from 'axios'

export default {
  async getCustomerTypes() {
    const result = await axios.get('GetCustomerTypes')

    if (result.status == 200) return result.data

    return []
  },
}
